import { render, staticRenderFns } from "./globalPayConfig.vue?vue&type=template&id=91d1025a&scoped=true"
import script from "./globalPayConfig.vue?vue&type=script&lang=js"
export * from "./globalPayConfig.vue?vue&type=script&lang=js"
import style0 from "./globalPayConfig.vue?vue&type=style&index=0&id=91d1025a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91d1025a",
  null
  
)

export default component.exports